import { Button, Row } from 'antd';
import { MdArrowBackIos } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

function BackButtonComponent({ onClick }: { onClick?: () => void }) {
    const navigate = useNavigate();

    return (
        <Row style={{ marginBottom: '0.5rem' }}>
            <Button type='dashed' htmlType='button' onClick={onClick ?? (() => navigate(-1))} icon={<MdArrowBackIos size={18} />} className='icon-button'>Back</Button>
        </Row>
    );
}

export default BackButtonComponent;